// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__1YKGK","label":"style_label__183R0","actions":"style_actions__48Cmu","input":"style_input__1n_p1"};